import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";

const Editor = props => {
  const [value, setValue] = useState(props.value ?? '');
  const [initialValue, setInitialValue] = useState(props.initialValue);

  useEffect(() => {
    if (props.forcePlaceholderTextUpdate)
    {
      setValue(props.value)
    }
  }, [props.forcePlaceholderTextUpdate, props.value]);

  useAfterUpdateEffect(() => {
    if (props.forcePlaceholderTextUpdate) {
      props.onChange(null);
    } else if (initialValue) {
      setInitialValue(false);
    } else {
      props.onChange(value);
    }
  }, [value, props.forcePlaceholderTextUpdate]);


  return <ReactQuill
    theme="snow"
    value={value}
    onChange={setValue}
    modules={{
      toolbar: [
        ['bold', 'italic', 'underline'],
      ]
    }}
  />
};

Editor.defaultProps = {
  forcePlaceholderTextUpdate: false,
  initialValue: false,
}

Editor.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  forcePlaceholderTextUpdate: PropTypes.bool,
  initialValue: PropTypes.bool,
};

export default Editor;